import styled, { keyframes } from "styled-components";
export const SIZES = {
    CANCEL_PANEL_WIDTH: 225,
    CANCEL_PANEL_HEIGHT: 220,
    LOADER_HEIGHT: 10
};
const loaderAnimation = keyframes `
  0% { left: 0; transform: translateX(-100%); }
  100% { left: 100%; transform: translateX(0%); }
`;
export default {
    Container: styled.div `
    top: calc(50% - ${SIZES.CANCEL_PANEL_HEIGHT / 2}px);
    left: calc(50% - ${SIZES.CANCEL_PANEL_WIDTH / 2}px);
    height: ${SIZES.CANCEL_PANEL_HEIGHT}px;
    width: ${SIZES.CANCEL_PANEL_WIDTH}px;
  `,
    Loader: styled.div `
    position: relative;
    height: ${SIZES.LOADER_HEIGHT}px;
    width: ${SIZES.CANCEL_PANEL_WIDTH}px;
    border-radius: ${({ theme }) => theme["border-radius-lg"]};
    overflow: hidden;
    background-color: ${({ theme }) => theme["gray-100"]};

    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 1px;
      left: 0;
      width: 50%;
      height: ${SIZES.LOADER_HEIGHT - 2}px;
      background: linear-gradient(
        90deg,
        transparent 0%,
        ${({ theme }) => theme["brand-primary-600"]} 29.75%,
        ${({ theme }) => theme["brand-primary-600"]} 70.76%,
        transparent 100%
      );
      animation: ${loaderAnimation} 2s linear infinite;
    }
  `
};
